import styled from "styled-components";
import Container from "components/core/container";

export const MainContainer = styled(Container)`
  margin-top: 62px;
  min-height: calc(100dvh - 62px);
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  &.main-layout-auth {
    padding: 0;
    margin-top: 0;
    min-height: 100dvh;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  @media (max-width: 768px) {
    margin-top: 0;
    margin-bottom: 0;
    min-height: calc(100dvh - 126px);
    &.main-layout-auth {
      min-height: 100dvh;
      margin-bottom: 0;
    }
  }
`;

export const FormWrapper = styled(Container)`
  @media (min-width: 768px) {
    margin: 64px auto;
    max-width: 600px;
    background: rgba(0, 107, 255, 0.05);
    padding: 32px;
    h3 {
      text-align: center;
    }
  }
`;
